module.exports = __webpack_public_path__ + "static/team-2-1-52c3b5b84117d87b40a077e25a745c02.jpg";